import { ReactSortable } from "react-sortablejs";
import { BackArrow } from "../../../assets/icons/BackArrow";
import { history } from "../../../store/index";
import { SixDots } from "../../../assets/icons/SixDots";
import { Eye } from "../../../assets/icons/Eye";
import { EyeClosed } from "../../../assets/icons/EyeClosed";
import { MFButton } from "../../../common/components/MFButton";
import { defaultCalculsColumns } from "../../user/constants";
import { useEffect, useState } from "react";
import { InfoCircle } from "../../../assets/icons/InfoCircle";
import CustomTooltip from "../../../common/components/CustomTooltip";

const CalculsParameters = ({ updateCalculsColumns, calculsColumns }) => {
  const [columns, setColumns] = useState(calculsColumns);
  const nameColumn = columns.find((col) => col.value === "name");
  const otherColumns = columns.filter((col) => col.value !== "name");

  useEffect(() => {
    setColumns(calculsColumns);
  }, []); // eslint-disable-line

  const handleListChange = (newList, _, store) => {
    if (
      store.dragging &&
      store.dragging.props &&
      JSON.stringify(store.dragging.props.list) !== JSON.stringify(newList)
    ) {
      const payload = [
        nameColumn,
        ...newList.map((t, index) => {
          return { ...t, order: index + 2 };
        }),
      ];
      setColumns(payload);
      updateCalculsColumns(payload);
    }
  };

  const resetParams = () => {
    setColumns(defaultCalculsColumns);
    updateCalculsColumns(defaultCalculsColumns);
  };

  const manageVisibility = (columnValue) => {
    const updatedColumns = columns.map((col) => {
      if (col.value === columnValue) {
        return { ...col, active: !col.active };
      }
      return col;
    });
    setColumns(updatedColumns);
    updateCalculsColumns(updatedColumns);
  };

  return (
    <>
      <div className="d-flex mb-2 align-items-center" style={{ height: 48 }}>
        <div className="d-flex align-items-center">
          <button onClick={() => history.go(-1)} className="no-style">
            <BackArrow size={24} className="text-black" />
          </button>
          <span className="ml-2 folder-label-header text-table-black">
            Paramètres
          </span>
        </div>
      </div>
      <div className="card-container">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="d-flex flex-column description">
            <h5 className="text-primary-black title">
              Personnalisation d’affichage
            </h5>
            <span className="mb-1">
              Affichez, masquez ou réorganisez les colonnes de votre tableau de
              calcul.
              <br />
              Pour changer l’ordre des colonnes : réorganisez les lignes
              ci-dessous en les déplaçant.
            </span>
            <span>Les colonnes apparaitront dans cet ordre :</span>
          </div>
          <span
            className="cursor-pointer"
            data-toggle="dropdown"
            data-tooltip-id="parameters-info"
            onClick={(e) => e.stopPropagation()}
            onMouseEnter={(e) => e.stopPropagation()}
          >
            <InfoCircle className="text-primary-black" />
          </span>
          <CustomTooltip id="parameters-info" place="bottom" dark>
            <div className="text">
              Ces réglages impactent la vue avec tous vos calculs mais aussi
              l’affichage au sein des dossiers
            </div>
          </CustomTooltip>
        </div>

        <ColumnItem column={nameColumn} />
        <ReactSortable
          list={[
            ...otherColumns
              .sort((a, b) => a.order - b.order)
              .map((col) => {
                return { ...col, chosen: true };
              }),
          ]}
          setList={handleListChange}
          className="sortable-columns"
        >
          {[...otherColumns]
            .sort((a, b) => a.order - b.order)
            .map((column) => (
              <ColumnItem
                key={column.value}
                column={column}
                manageVisibility={manageVisibility}
              />
            ))}
        </ReactSortable>

        <MFButton outlined className="mt-3" big onClick={resetParams}>
          Réinitialiser les réglages
        </MFButton>
      </div>
    </>
  );
};

export default CalculsParameters;

const ColumnItem = ({ column, manageVisibility }) => {
  return (
    <div className="sortable-column d-flex align-items-center justify-content-between">
      <div
        className={`d-flex align-items-center text-primary-black ${!!column.active ? "" : "text-primary-black-disabled"}`}
      >
        <SixDots
          size={20}
          className={`mr-1 ${column.value === "name" ? "opacity-50" : ""} ${!!column.active ? "text-interaction" : "text-primary-black-disabled"}`}
        />
        {column.label}
      </div>
      {column.value === "name" ? (
        <span className="not-sortable">Ne peut pas être masqué ou déplacé</span>
      ) : (
        <button
          className="eye-button"
          onClick={() => manageVisibility(column.value)}
        >
          {!!column.active ? (
            <Eye size={20} className="text-interaction" />
          ) : (
            <EyeClosed size={20} className="text-interaction" />
          )}
        </button>
      )}
    </div>
  );
};
